import { service } from '../api/axios';

export const postCategory = async (label: string) => {
  await service
    .post(`/categories`, { label })
    .then((responseFromAPI) => responseFromAPI.data);
};

export const deleteCategory = async (id: string) => {
  await service
    .delete(`/categories/${id}`)
    .then((responseFromAPI) => responseFromAPI.data);
};
